import React, { Fragment, useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import MetaTags from "react-meta-tags";
import LayoutOne from "../../layouts/LayoutOne";
import { useReactToPrint } from "react-to-print";
import { connect } from "react-redux";
import { Card, Spin } from "antd";
import { useHistory } from "react-router-dom";
import { store } from "../..";
import OrderInvoice from "../invoices/OrderInvoice";
import { fetchOrderById } from "../../redux/actions/checkoutActions";
import isEmpty from "lodash/isEmpty";
import Button from "../../components/utils/Button";

const ShowInvoice = ({
  // cartItems,
  currency,
  userDetail,
  // orderDetail,
  singleOrder,
  // decreaseQuantity,
  // addToCart,
  // deleteFromCart,
  // deleteAllFromCart,
}) => {
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const bodyRef = useRef(null);
  useEffect(() => {
    getOrder(history.location.pathname.split("/")[2]);
  }, []);

  const handlePrint = useReactToPrint({
    content: () => bodyRef.current,
    documentTitle: `Invoice(${singleOrder.no})`,
  });

  const getOrder = (id) => {
    try {
      setLoading(true);
      store.dispatch(fetchOrderById(id, userDetail, setLoading, history));
    } catch (err) {
      setLoading(false);
    }
  };

  return (
    <>
      <Fragment>
        <MetaTags>
          <title>{currency?.ecom_title} | Order Invoice</title>
          <meta
            name="description"
            content={`Invoice Page of ${currency?.ecom_title} eCommerce template.`}
          />
        </MetaTags>

        {/* <BreadcrumbsItem to={process.env.PUBLIC_URL + "/"}>
          Home
        </BreadcrumbsItem>
        <BreadcrumbsItem
          to={process.env.PUBLIC_URL + history.location.pathname}
        >
          Order Invoice
        </BreadcrumbsItem>
*/}
        <LayoutOne headerTop="visible">
          {/* breadcrumb
          <Breadcrumb /> */}
          <center>
            <div className="mt-40 mb-40 w-75">
              <Card
                extra={
                  <div>
                    <Button
                      onClick={() => {
                        // createPdf(bodyRef.current);
                        handlePrint();
                      }}
                    >
                      Print / Save Invoice
                    </Button>
                    <Button
                      onClick={() => {
                        history.push(`/order-history`);
                      }}
                    >
                      Close
                    </Button>
                  </div>
                }
              >
                <Spin spinning={loading}>
                  {!isEmpty(singleOrder) && (
                    <div ref={bodyRef} id="invoice" className="pdf-body">
                      <OrderInvoice order={singleOrder} currency={currency} />
                    </div>
                  )}
                </Spin>
              </Card>
            </div>
          </center>
        </LayoutOne>
      </Fragment>
    </>
  );
};
ShowInvoice.propTypes = {
  //   addToCart: PropTypes.func,
  //   cartItems: PropTypes.array,
  currency: PropTypes.object,
  //   orderDetail: PropTypes.object,
  singleOrder: PropTypes.object,
  userDetail: PropTypes.object,
  //   decreaseQuantity: PropTypes.func,
  //   location: PropTypes.object,
  //   deleteAllFromCart: PropTypes.func,
  //   deleteFromCart: PropTypes.func,
};
const mapStateToProps = (state) => {
  return {
    cartItems: state.cartData,
    currency:state.settingData?.["admin-panel"]?.basic||{},
    userDetail: state.userData,
    orderDetail: state.saleData.orderEntities,
    singleOrder: state.saleData.singleOrder,
  };
};
export default connect(mapStateToProps)(ShowInvoice);